export default __webpack_public_path__ + "static/modal-subscribe2-f7e060907f55b740e8e930c679def5c1.jpg";